import { useLocation } from 'react-router-dom';

export const useLoginUrl = () => {
  const { pathname, search } = useLocation();

  return `/login?backUrl=${encodeURIComponent(pathname + search)}`;
};
